var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-switch',{staticClass:"theme-switch",attrs:{"value":_vm.isLight,"active-color":"#3348F6","inactive-color":"#3348F6","activeIconClass":"dark-mode","inactiveIconClass":"light-mode"},on:{"change":_vm.themeModeChange}})}
var staticRenderFns = []

export { render, staticRenderFns }